import { createFeature, createReducer, on } from '@ngrx/store';
import { DownloadLeaseAgreementData, DownloadLeaseAgreementState } from '../../interfaces/download-lease-agreement';
import * as DownloadLeaseAgreementFormActions from './download-lease-agreement.action';

const initialState: DownloadLeaseAgreementState = {
    data: {
        fileName: '',
        fileData: ''
    },
    isSubmittingSuccess: false,
    isSubmittingError: false
}

const LoadDownloadLeaseAgreementActionFunction: any =
    (state: DownloadLeaseAgreementState) => ({ ...state, loading: true, isSubmittingSuccess: false, isSubmittingError: false });

const DownloadLeaseAgreementDataSuccessActionFunction: any =
    (state: DownloadLeaseAgreementState, action: { data: DownloadLeaseAgreementData }) => ({ ...state, data: { ...action.data }, loading: false, isSubmittingSuccess: true, isSubmittingError: false });

const DownloadLeaseAgreementDataErrorFunction: any =
    (state: DownloadLeaseAgreementState) => ({ ...state, loading: false, isSubmittingSuccess: false, isSubmittingError: true });

const resetDownloadLeaseAgreementDataFunction: any =
    (state: DownloadLeaseAgreementState) => ({ ...initialState });

export const DownloadLeaseAgreementFeatureName = 'DownloadLeaseAgreement';

export const DownloadLeaseAgreementFeature = createFeature({
    name: DownloadLeaseAgreementFeatureName,
    reducer: createReducer(
        initialState,
        on(DownloadLeaseAgreementFormActions.LoadDownloadLeaseAgreementAction, LoadDownloadLeaseAgreementActionFunction),
        on(DownloadLeaseAgreementFormActions.DownloadLeaseAgreementDataSuccessAction, DownloadLeaseAgreementDataSuccessActionFunction),
        on(DownloadLeaseAgreementFormActions.DownloadLeaseAgreementDataError, DownloadLeaseAgreementDataErrorFunction),
        on(DownloadLeaseAgreementFormActions.resetDownloadLeaseAgreementData, resetDownloadLeaseAgreementDataFunction),
    )
})